module.exports = __webpack_public_path__ + "img/reslove.97d92c7a.png";